import React, { type ReactElement } from 'react';
import clsx from 'clsx';

type Props = {
  className?: string;
  children: React.ReactNode;
};

/**
 * Provides a standardised approach to presenting a form label and input together. Also contains
 * the error message if there is one.
 */
export default function FormLabelAndInputContainer({ className, children }: Props): ReactElement {
  return <div className={clsx(className, 'mb-4')}>{children}</div>;
}
